// extracted by mini-css-extract-plugin
export default {"localeTabs":"localeTabs_localeTabs__89HmI","localePill":"localeTabs_localePill__+93n8","localePillActive":"localeTabs_localePillActive__qzSvi"};